import BiasSearch from './BiasSearch';

export default BiasSearch;
